import type { Verbindung } from './verbindung'

/**
 * Die eine offene Verbindung zum Fernseher, falls es sie gibt.
 *
 * Bewusst ein Modul-Singleton und kein React-Context: Die Verbindung
 * ueberlebt Seitenwechsel innerhalb der App (Koppeln, dann Ueben, dann
 * Abschluss), und ein Context muesste dafuer ueber der gesamten App haengen,
 * obwohl ihn drei Stellen brauchen.
 */
let verbindung: Verbindung | null = null

export function verbindungSetzen(neu: Verbindung | null): void {
  verbindung = neu
}

export function aktiveVerbindung(): Verbindung | null {
  return verbindung
}

export function verbindungBeenden(): void {
  verbindung?.schliessen()
  verbindung = null
}
